import Fare from './Fare';

export default Fare;
